<mat-dialog-content>
    <div class="spinner-center" *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <ng-container *ngIf="!loading">
        <div class="div-row">
            <div class="title">
                <span *ngIf="!data?.loanActionType || data?.loanActionType === LoanActionTypes.CreateLoan">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CREATE.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.loanActionType === LoanActionTypes.ViewLoan">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.VIEW.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.loanActionType === LoanActionTypes.ValidateLoan">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.VALIDATE.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.loanActionType === LoanActionTypes.EditLoan">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.EDIT.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.loanActionType === LoanActionTypes.GrantLoan">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.GRANT.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.loanActionType === LoanActionTypes.ReturnLoan">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.RETURN.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.loanActionType === LoanActionTypes.ValidateRenewLoan">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.VALIDATE_RENEW.TITLE' | translate |
                    uppercase
                    }}</span>

                <span *ngIf="udeuLoan?.name as name" class="ml5">{{name}}</span>
            </div>
            <div class="action-buttons">
                <button mat-raised-button
                    [color]="data?.loanActionType === LoanActionTypes.ViewLoan ? 'primary' : (data?.loanActionType === LoanActionTypes.ValidateLoan || data?.loanActionType === LoanActionTypes.ValidateRenewLoan) ? 'accent' : 'warn'"
                    (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                </button>

                <button mat-raised-button
                    [color]="data?.loanActionType === LoanActionTypes.EditLoan ? 'primary' : 'accent'"
                    *ngIf="data?.loanActionType === LoanActionTypes.EditLoan || data?.loanActionType === LoanActionTypes.GrantLoan"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.EDIT.DIALOG.TITLE' | translate"
                    (click)="createLoan(true)">
                    <mat-icon>save</mat-icon>
                </button>

                <button mat-raised-button color="primary" *ngIf="data?.loanActionType === LoanActionTypes.GrantLoan"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.GRANT.TITLE' | translate"
                    (click)="createLoan()" [disabled]="mainFormGroup.invalid">
                    <mat-icon>assignment</mat-icon>
                </button>

                <button mat-raised-button color="primary" *ngIf="data?.loanActionType === LoanActionTypes.ReturnLoan"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.RETURN.TITLE' | translate"
                    (click)="changeStatusLoan(UDEU_LOAN_RETURNED_STATUS)" [disabled]="mainFormGroup.invalid">
                    <mat-icon>assignment_returned</mat-icon>
                </button>

                <button mat-raised-button color="primary" *ngIf="data?.loanActionType === LoanActionTypes.FinishLoan"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.FINISH.TITLE' | translate"
                    (click)="changeStatusLoan(UDEU_LOAN_FINISHED_STATUS)" [disabled]="mainFormGroup.invalid">
                    <mat-icon>assignment_late</mat-icon>
                </button>

                <button mat-raised-button color="primary"
                    *ngIf="!data?.loanActionType || data?.loanActionType === LoanActionTypes.CreateLoan"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CREATE.TITLE' | translate"
                    (click)="createLoan()" [disabled]="mainFormGroup.invalid">
                    <mat-icon>add_circle</mat-icon>
                </button>

                <ng-container *ngIf="data?.loanActionType === LoanActionTypes.ValidateLoan">
                    <button mat-raised-button color="warn" [matTooltip]="'Rechazar préstamo' | translate"
                        [disabled]="mainFormGroup.invalid" (click)="changeStatusLoan(UDEU_LOAN_REJECTED_STATUS)">
                        <mat-icon>block</mat-icon>
                    </button>
                    <button mat-raised-button color="primary" [matTooltip]="'Aceptar préstamo' | translate"
                        [disabled]="mainFormGroup.invalid" (click)="changeStatusLoan(UDEU_LOAN_ACCEPTED_STATUS)">
                        <mat-icon>check_circle</mat-icon>
                    </button>
                </ng-container>

                <ng-container *ngIf="data?.loanActionType === LoanActionTypes.ValidateRenewLoan">
                    <button mat-raised-button color="warn" [matTooltip]="'Rechazar renovación del préstamo' | translate"
                        [disabled]="mainFormGroup.invalid" (click)="openRenew(true)">
                        <mat-icon>block</mat-icon>
                    </button>
                    <button mat-raised-button color="primary"
                        [matTooltip]="'Aceptar renovación del préstamo' | translate" [disabled]="mainFormGroup.invalid"
                        (click)="openRenew()">
                        <mat-icon>check_circle</mat-icon>
                    </button>
                </ng-container>
            </div>
        </div>
        <mat-stepper #matStepper orientation="horizontal" [linear]="false" [selectedIndex]="selectedIndex"
            *ngIf="udeuService.getStepsFiltered(steps) as stepsList"
            [ngClass]="stepsList.length === 1 ? 'stepper-hide-header' : ''">
            <ng-container *ngFor="let step of stepsList; let i = index">
                <ng-container *ngIf="step.form.group as formGroup">
                    <mat-step #matStep [stepControl]="formGroup" *ngIf="!step.disabled"
                        [completed]="isCompleted(matStep)">
                        <ng-template matStepperIcon="edit"><mat-icon>check</mat-icon></ng-template>
                        <ng-template matStepperIcon="number"><mat-icon>none</mat-icon></ng-template>
                        <ng-template matStepLabel><span [matTooltip]="step.name | translate">{{step.name |
                                translate
                                }}</span></ng-template>
                        <form [formGroup]="formGroup">
                            <div class="formDiv">
                                <ng-container *ngIf="step.type === StepTypes.GENERIC; else special">
                                    <ng-container *ngFor="let controlName of udeuService.getObjectKeys(formGroup)">
                                        <ng-container *ngIf="step.form.fields[controlName] as formField">
                                            <ng-container *ngIf="!formField.disabled">
                                                 <div *ngIf="(formField.type === MatFormFieldType.SELECT && formField.options?.length > 0) 
                                                                || (formField.type === MatFormFieldType.SELECT && formGroup.controls[controlName].value)"
                                                            [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                            class="editMassiveRecord-div-row">
                                                        <smt-search-select [useChips] = "false"
                                                            [group]="formGroup" [controlName]="controlName"
                                                            [label]="formField.label" [options]="formField.options"
                                                            (optionSelected)="udeuService.formFieldChangeFunc(formField, $event.option.value)"
                                                            (optionChanged)="udeuService.formFieldChangeFunc(formField, null)"></smt-search-select>
                                                          
                                                    </div>
                                                <div *ngIf="formField.type === MatFormFieldType.INPUT"
                                                    [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                    <mat-form-field class="w100">
                                                        <mat-label>{{formField.label | translate}}</mat-label>
                                                        <textarea matInput cdkTextareaAutosize
                                                            [placeholder]="formField.placeholder | translate"
                                                            [formControlName]="controlName"></textarea>
                                                    </mat-form-field>
                                                </div>

                                                <div *ngIf="formField.type === MatFormFieldType.BOOLEAN"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                        <mat-button-toggle-group [formControlName]="controlName">
                                                            <mat-button-toggle color="primary" [value]="true">{{
                                                                formField.placeholder |
                                                                translate }}</mat-button-toggle>
                                                            <mat-button-toggle color="primary" [value]="false">{{
                                                                formField.extraPlaceholder | translate
                                                                }}</mat-button-toggle>
                                                        </mat-button-toggle-group>
                                                    </div>

                                                <smt-date-input
                                                    *ngIf="formField.type === MatFormFieldType.DATE"
                                                    [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                    [group]="formGroup" [controlName]="controlName"
                                                    [label]="formField.label"
                                                    [dateType]="controlName === 'lastYearEnrollment' ? DateType.YEAR : DateType.DATE"></smt-date-input>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <ng-template #special>
                                    <ng-container *ngIf="step.type === StepTypes.LENTS">
                                        <alden-registers class="w100" [loan]="udeuLoan" [group]="registersFormGroup"
                                            [controlName]="'registers'" [isManager]="isManager"></alden-registers>
                                    </ng-container>
                                </ng-template>
                            </div>
                        </form>
                    </mat-step>
                </ng-container>
            </ng-container>
        </mat-stepper>
    </ng-container>
</mat-dialog-content>